import React, { FC } from "react";

import { I18nKeyType } from "@/i18n";
import { useTranslator } from "@/i18n/useTranslator";
import { classNames } from "@/src/utils/classNames";

import { DsLoading } from "./DsLoading";
import { DsText } from "./DsText";

type DsDataDisplayPropsType = {
  title: I18nKeyType;
  data?: string | React.ReactElement | null;
  dataClassName?: string;
  onEditClick?: () => void;
  isLoading?: boolean;
  shouldShowBorderBottom?: boolean;
};

const DsDataDisplay: FC<DsDataDisplayPropsType> = ({
  title,
  data,
  dataClassName,
  onEditClick,
  isLoading,
  shouldShowBorderBottom = true,
}) => {
  const { t } = useTranslator();

  return (
    <div
      className={classNames(
        "py-4 sm:grid sm:grid-cols-3 sm:gap-4",
        shouldShowBorderBottom && "border-b border-[#DADADA]",
      )}>
      <dt>
        <DsText variant="dataDisplayTitle">{t(title)}</DsText>
      </dt>
      <dd
        className={classNames(
          "mt-1 flex text-base font-medium leading-5 text-black sm:col-span-2 sm:mt-0",
          dataClassName,
        )}>
        <span className="grow">{data ?? "--"}</span>
        {onEditClick && (
          <span className="ml-4 shrink-0">
            {isLoading ? (
              <DsLoading size="small" />
            ) : (
              <DsText
                onClick={onEditClick}
                variant="button"
                className="text-[#BD5100] bg-transparent hover:cursor-pointer">
                {t("edit")}
              </DsText>
            )}
          </span>
        )}
      </dd>
    </div>
  );
};

export { DsDataDisplay };
